import { Type } from "@sinclair/typebox";
import { MsgrDeviceStatusSchema } from "./device";
import { Nullable, NullableNumber } from "../../utils/typeboxTypes";
export const MsgrDevicePresenceSchema = Type.Object({
    id: Type.Number(),
    device_id: NullableNumber,
    uid: Type.String({ maxLength: 50 }),
    status: MsgrDeviceStatusSchema,
    created_at: Nullable(Type.Date({ default: () => new Date() })),
    updated_at: Nullable(Type.Date({ default: () => new Date() })),
});
// 1	id	bigint(20)	NULL	NULL	NO	NULL	auto_increment
// 2	device_id	bigint(20)	NULL	NULL	YES	NULL		msgr_devices(id)
// 3	uid	varchar(50)	utf8mb4	utf8mb4_unicode_ci	NO	NULL
// 4	status	varchar(255)	utf8mb4	utf8mb4_unicode_ci	NO	NULL
// 5	created_at	timestamp	NULL	NULL	YES	NULL
// 6	updated_at	timestamp	NULL	NULL	YES	NULL
